import { path } from 'ramda';

import { FEATURE_NAME } from './consts';

export const getCandidate = path([FEATURE_NAME]);
export const getCandidateProp = (name) => path([FEATURE_NAME, name]);
